<script>
import { router } from './router';

export let path;
export let component = null;
let params;

$: params = $router.matches(path);
</script>

{#if params}
  {#if component}
    <svelte:component this={component} {...params}/>
  {:else}
    <slot {params}></slot>
  {/if}
{/if}
